var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.75L7.11311 6.79554C6.6058 8.1665 6.35215 8.852 5.85209 9.3521C5.35202 9.85213 4.66653 10.1058 3.29554 10.6131L2.25 11L3.29554 11.3869C4.66653 11.8942 5.35202 12.1479 5.85209 12.6479C6.35215 13.148 6.6058 13.8335 7.11311 15.2044L7.5 16.25L7.88685 15.2044C8.39423 13.8335 8.64787 13.148 9.1479 12.6479C9.648 12.1479 10.3335 11.8942 11.7044 11.3869L12.75 11L11.7044 10.6131C10.3335 10.1058 9.648 9.85213 9.1479 9.3521C8.64787 8.852 8.39423 8.1665 7.88685 6.79554L7.5 5.75Z",
    stroke: "#1966FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.75L13.3342 3.19809C13.1168 3.78565 13.0081 4.07944 12.7937 4.29375C12.5795 4.50806 12.2857 4.61677 11.6981 4.83419L11.25 5L11.6981 5.16581C12.2857 5.38323 12.5795 5.49194 12.7937 5.70625C13.0081 5.92056 13.1168 6.21435 13.3342 6.80191L13.5 7.25L13.6658 6.80191C13.8832 6.21435 13.9919 5.92056 14.2063 5.70624C14.4205 5.49194 14.7143 5.38323 15.3019 5.16581L15.75 5L15.3019 4.83419C14.7143 4.61677 14.4205 4.50806 14.2063 4.29375C13.9919 4.07944 13.8832 3.78565 13.6658 3.19809L13.5 2.75Z",
    stroke: "#1966FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseStar);
export default __webpack_public_path__ + "static/media/license-star.b8f0362d2c3ec404aee7628b971157cd.svg";
export { ForwardRef as ReactComponent };